"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _getFilteredPropertyOptions = _interopRequireDefault(require("composer-plugins/utils/getFilteredPropertyOptions"));

var _PropertyQuickReplyInput = _interopRequireDefault(require("./PropertyQuickReplyInput"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var getMemoizedPropertyOptions = (0, _memoize.default)(_getFilteredPropertyOptions.default);
var getMemoizedPropertyTypeOptions = (0, _memoize.default)(function (properties) {
  return properties.keySeq().toArray().map(function (objectType) {
    return {
      text: _I18n.default.text("composer-plugins.questionAndAnswer.propertyTypes." + objectType),
      value: objectType
    };
  });
});

var _default = (0, _createReactClass.default)({
  displayName: "EditPropertyQuickReplyInput",
  propTypes: {
    question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
    onChange: _propTypes.default.func.isRequired,
    properties: _propTypes.default.instanceOf(_immutable.Map).isRequired
  },
  handlePropertyTypeChanged: function handlePropertyTypeChanged(e) {
    this.props.onChange(this.props.question.setObjectType(e.target.value));
  },
  handlePropertyChanged: function handlePropertyChanged(e) {
    var _this$props = this.props,
        properties = _this$props.properties,
        onChange = _this$props.onChange,
        question = _this$props.question;
    var propertyName = e.target.value;
    var property = propertyName ? properties.getIn([question.objectType, 'properties', propertyName]) : null;
    onChange(question.setProperty(property));
  },
  renderPropertyGroupSelect: function renderPropertyGroupSelect() {
    var _this$props2 = this.props,
        question = _this$props2.question,
        properties = _this$props2.properties;
    var propertyTypeOptions = getMemoizedPropertyTypeOptions(properties);
    return _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.questionAndAnswer.propertyType"
      }),
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.questionAndAnswer.propertyTypeTooltip"
      }),
      tooltipPlacement: "right",
      className: "m-bottom-3"
    }, _react.default.createElement(_UISelect.default, {
      className: "question-and-answer-contact-property-select",
      onChange: this.handlePropertyTypeChanged,
      options: propertyTypeOptions,
      value: question.objectType,
      placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.selectPropertyType'),
      "data-selenium-test": "question-and-answer-select-component",
      dropdownClassName: "question-and-answer-property-select-dropdown"
    }));
  },
  renderPropertyLoadingError: function renderPropertyLoadingError() {
    var _this$props3 = this.props,
        question = _this$props3.question,
        properties = _this$props3.properties;
    var propertiesForType = properties.get(question.objectType);
    var selectedProperty = properties.getIn([question.objectType, 'properties', question.propertyName]);
    var failedLoadingSelected = question.propertyName && !selectedProperty;

    if (propertiesForType && !failedLoadingSelected) {
      return null;
    }

    return _react.default.createElement(_UIAlert.default, {
      type: "danger"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.errorLoadingProperties"
    }));
  },
  renderPropertySelect: function renderPropertySelect() {
    var _this$props4 = this.props,
        question = _this$props4.question,
        properties = _this$props4.properties;

    if (!question.objectType) {
      return null;
    }

    var propertiesForType = properties.get(question.objectType);

    if (!propertiesForType) {
      return null;
    }

    var propertyOptions = getMemoizedPropertyOptions(propertiesForType);
    return _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.questionAndAnswer.properties." + question.objectType
      }),
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.questionAndAnswer.propertiesTooltip"
      }),
      tooltipPlacement: "right",
      className: "m-bottom-3"
    }, _react.default.createElement(_UISelect.default, {
      className: "question-and-answer-contact-property-select",
      onChange: this.handlePropertyChanged,
      options: propertyOptions,
      value: question.propertyName,
      placeholder: _I18n.default.text("composer-plugins.questionAndAnswer.selectProperty." + question.objectType),
      "data-selenium-test": "question-and-answer-select-component",
      dropdownClassName: "question-and-answer-property-select-dropdown"
    }));
  },
  renderOptionsPreview: function renderOptionsPreview() {
    var _this$props5 = this.props,
        question = _this$props5.question,
        properties = _this$props5.properties;

    if (!question.propertyName) {
      return null;
    }

    var selectedProperty = properties.getIn([question.objectType, 'properties', question.propertyName]);

    if (!selectedProperty) {
      return null;
    }

    return _react.default.createElement("div", null, _react.default.createElement(_UIFormLabel.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.answers"
    })), _react.default.createElement(_PropertyQuickReplyInput.default, {
      question: question.setProperty(selectedProperty),
      objectProperty: selectedProperty,
      disabled: true
    }));
  },
  render: function render() {
    if (!this.props.question.isPropertyQuickReply()) {
      return null;
    }

    return _react.default.createElement("div", null, this.renderPropertyGroupSelect(), this.renderPropertySelect(), this.renderOptionsPreview());
  }
});

exports.default = _default;
module.exports = exports.default;